import formatRFC3339 from 'date-fns/formatRFC3339';
import keycloakService from '../../keycloak_service';

import { get_results_request } from '../../components/assays/V2Assays/conversions';
import { sinatraOrigin } from '../../config';

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

export const fetchAssayResults = (queryParams) => {
  const [assay_id, startTimestamp, endTimestamp, isAssaysV2Enabled] = queryParams;
  const params = { assay_id };

  if (startTimestamp && endTimestamp) {
    params.start = formatRFC3339(startTimestamp);
    params.end = formatRFC3339(endTimestamp);
  }

  let body = JSON.stringify(params)
  let path = 'v1/api/assays/get_assay_results'
  /**
   * @deprecated Assays V1 Logic
   */
  if (isAssaysV2Enabled) {
    body = JSON.stringify(get_results_request(assay_id, formatRFC3339(startTimestamp), formatRFC3339(endTimestamp)));
    path = 'v2/api/assays/get_results'
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body,
  };

  return postToApi(path, fetchOptions)
}

export default fetchAssayResults;
